angular.module('AcaApp').directive('hideSovos', hideSovosDirective);


hideSovosDirective.$inject = [
  'PARTICIPANT_FORM'
];

function hideSovosDirective(PARTICIPANT_FORM) {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$formatters.push(function(inputValue) {
        if(inputValue == PARTICIPANT_FORM.NO_CITY) {
          return '';
        }

        return inputValue;
      });
      ngModel.$parsers.push(function(inputValue) {
        if(inputValue == 0) {
          ngModel.$setViewValue('');
          ngModel.$render();
        }

        return inputValue;
      });
    }
  };
};
